import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true }
  },
  // 管理员布局
  {
    path: '/',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    redirect: '/dashboard',
    meta: { requireAdmin: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '数据概览' }
      },
      {
        path: 'admins',
        name: 'Admins',
        component: () => import('../views/Admins.vue'),
        meta: { title: '管理员管理' }
      },
      {
        path: 'doctors',
        name: 'Doctors',
        component: () => import('../views/Doctors.vue'),
        meta: { title: '推荐人管理' }
      },
      {
        path: 'members',
        name: 'Members',
        component: () => import('../views/Members.vue'),
        meta: { title: '会员管理' }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('../views/Products.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('../views/Orders.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'refunds',
        name: 'Refunds',
        component: () => import('../views/Refunds.vue'),
        meta: { title: '退款管理' }
      },
      {
        path: 'doctor-stats',
        name: 'DoctorStats',
        component: () => import('../views/DoctorStats.vue'),
        meta: { title: '推荐人业绩统计' }
      },
      {
        path: 'customer-service',
        name: 'CustomerService',
        component: () => import('../views/CustomerService.vue'),
        meta: { title: '客服消息' }
      }
    ]
  },
  // 医生布局
  {
    path: '/doctor',
    name: 'DoctorLayout',
    component: () => import('../views/DoctorLayout.vue'),
    redirect: '/doctor-dashboard',
    meta: { requireDoctor: true },
    children: [
      {
        path: '/doctor-dashboard',
        name: 'DoctorDashboard',
        component: () => import('../views/DoctorDashboard.vue'),
        meta: { title: '我的数据' }
      },
      {
        path: '/doctor-members',
        name: 'DoctorMembers',
        component: () => import('../views/DoctorMembers.vue'),
        meta: { title: '我的会员' }
      },
      {
        path: '/doctor-orders',
        name: 'DoctorOrders',
        component: () => import('../views/DoctorOrders.vue'),
        meta: { title: '我的订单' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userType = store.state.userType

  if (to.meta && to.meta.public) {
    // 公开页面
    if (token && to.path === '/login') {
      // 已登录，根据用户类型跳转
      if (userType === 'doctor') {
        next('/doctor-dashboard')
      } else {
        next('/')
      }
    } else {
      next()
    }
  } else {
    // 需要登录的页面
    if (!token) {
      next('/login')
      return
    }

    // 检查权限
    if (to.meta.requireAdmin && userType !== 'admin') {
      next('/login')
      return
    }

    if (to.meta.requireDoctor && userType !== 'doctor') {
      next('/login')
      return
    }

    next()
  }
})

export default router
